import { render, staticRenderFns } from "./TemplatePage.vue?vue&type=template&id=1289807c&scoped=true"
import script from "./TemplatePage.vue?vue&type=script&lang=js"
export * from "./TemplatePage.vue?vue&type=script&lang=js"
import style0 from "./TemplatePage.vue?vue&type=style&index=0&id=1289807c&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1289807c",
  null
  
)

export default component.exports